var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'core', 'view/report', 'component/range-selector', 'app-common/component/api-call', 'app-common/component/loader', 'app-common/component/infinite-scrolling', 'component/report/excel-files-table', 'template/report/landing.htm'], function($, core, ReportView, rangeSelector, apiCall, loader, infiniteScrolling, excelFilesTable, landingViewTemplate) {
  var ExcelDocumentsReport;
  return ExcelDocumentsReport = (function(_super) {

    __extends(ExcelDocumentsReport, _super);

    function ExcelDocumentsReport() {
      ExcelDocumentsReport.__super__.constructor.apply(this, arguments);
    }

    ExcelDocumentsReport.prototype.pageId = 'excel-documents';

    ExcelDocumentsReport.prototype.initialize = function(options, params) {
      options = _.extend(options, {
        title: 'Excel Documents',
        icon: 'ss-list ss-standard',
        features: ['date-range', 'search'],
        template: landingViewTemplate
      });
      this.excelFilesTable = excelFilesTable;
      ExcelDocumentsReport.__super__.initialize.call(this, options, params);
      this.data.items = [];
      this.initReportDateIntervals();
      return this.loadData();
    };

    ExcelDocumentsReport.prototype.initUI = function() {
      var searchTimeout,
        _this = this;
      ExcelDocumentsReport.__super__.initUI.apply(this, arguments);
      if (__indexOf.call(this.settings.features, 'edit') >= 0) {
        this.on('report:start-editing', function() {
          return _this.toggleEditing();
        });
      }
      this.on('report:before-load-transactions', this.beforeLoadTransactions);
      this.on('report:after-load-transactions', this.afterLoadTransactions);
      this.excelFilesTable.initReportTemplate($('.transactions-list'), [], this.getType(), function() {
        return _this.isCurrentReportFinished();
      });
      searchTimeout = null;
      return this.$el.find('.search-field').on('keyup', function(e) {
        clearTimeout(searchTimeout);
        return searchTimeout = setTimeout(function() {
          return _this.excelFilesTable.search($(e.currentTarget).val());
        }, 300);
      });
    };

    ExcelDocumentsReport.prototype.initDateRangeFeatureData = function() {
      var _this = this;
      return rangeSelector.init(function() {
        return _this.trigger('report:date-change');
      }, {
        disable: ['ALL', 'CUSTOM']
      });
    };

    ExcelDocumentsReport.prototype.dateChangeAction = function() {
      this.updateReportURLFromInterval();
      return this.loadData();
    };

    ExcelDocumentsReport.prototype.loadData = function(toPage, searchString) {
      var intervalAsDates, promise, queryParams,
        _this = this;
      intervalAsDates = rangeSelector.getIntervalAsDates();
      this.trigger('report:before-load-transactions', 1, searchString);
      loader.init();
      queryParams = $.param({
        from: intervalAsDates.from.toString('yyyy-MM-dd'),
        to: intervalAsDates.to.toString('yyyy-MM-dd')
      });
      promise = apiCall('file', "client/" + (core.getCurrentClientId()) + "/tabular?" + queryParams, 'GET');
      return promise.done(function(data) {
        var file, _i, _len;
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        for (_i = 0, _len = data.length; _i < _len; _i++) {
          file = data[_i];
          _this.data.items.push(file);
        }
        return _this.trigger('report:after-load-transactions', data, 1, searchString);
      });
    };

    ExcelDocumentsReport.prototype.prepareTransactionsUI = function(items) {
      return this.excelFilesTable.initReportTemplate($('.widget .widget_content'), items);
    };

    ExcelDocumentsReport.prototype.afterLoadTransactions = function(data, page, searchString) {
      return this.prepareTransactionsUI(data);
    };

    ExcelDocumentsReport.prototype.searchAction = function() {};

    ExcelDocumentsReport.prototype.getDownloadUrl = function() {};

    return ExcelDocumentsReport;

  })(ReportView);
});
